import { createApp } from 'vue';
import VueMultiselect from 'vue-multiselect';
import Paginate from 'vuejs-paginate-next';
import { ProductListItem } from './product';
import { CategoryTree } from './categoryTree';
import { BaseCheckbox, BaseRadio } from '../../components/radioButtons';

const SearchPage = {
    template: '#search-page-template',
    components: {
        Multiselect: VueMultiselect
    },
    props: [
        'languageoptions',
        'organisationoptions',
        'statusoptions',
        'committeeoptions',
        'icsgrouptree',
        'directiveoptions',
        'searchresultel',
        'initSelectedDirectives',
        'initSelectedIcsGroups',
        'initSelectedLanguages',
        'initSelectedStatuses',
        'initSelectedCommitteeOption',
        'initSelectedOrganisations',
        'initOnlySuggestedProducts',
        'initOnlyNewEstonianLanguageProduct',
        'initQuery',
        'initPage',
        'initFilterType',
        'initOfficialJournalPublicationStartDate',
        'initOfficialJournalPublicationEndDate',
        'resetOfficialJournalPublicationStartDate',
        'resetOfficialJournalPublicationEndDate',
    ],
    data: function () {
        var self = this;

        return {
            searchType: self.initFilterType || 'filter',
            query: self.initQuery || '',
            selectedDirective: (self.initSelectedDirectives || []).map(function (value) {
                return self.directiveoptions.find(function (d) {
                    return d.value == value;
                })
            }),
            selectedIcsGroup: (self.initSelectedIcsGroups || []).map(function (value) {
                return self.setSelectedIcsGroups(self.icsgrouptree, value);
            }),
            selectedLanguage: self.initSelectedLanguages || [],
            selectedOrganisation: self.initSelectedOrganisations || [],
            selectedStatus: self.initSelectedStatuses || [],
            selectedCommitteeOption: self.initSelectedCommitteeOption,
            products: [],
            topics: [],
            page: self.initPage || 1,
            totalproducts: 0,
            totaltopics: 0,
            pageCount: 0,
            isLoading: false,
            onlysuggestedproducts: self.initOnlySuggestedProducts,
            onlyNewEstonianLanguageProduct: self.initOnlyNewEstonianLanguageProduct,
            officialJournalPublicationStartDate: self.initOfficialJournalPublicationStartDate,
            officialJournalPublicationEndDate: self.initOfficialJournalPublicationEndDate,
        }
    },
    created: function () {
        this.debouncedSearch = _.debounce(this.search, 10);
        this.debouncedLongSearch = _.debounce(this.search, 300);

        // Set first result synchronously on page load
        if (this.searchType == "topicPages") {
            this.setSearchResultsTopics(JSON.parse(document.getElementById(this.searchresultel).textContent));
        } else {
            this.setSearchResults(JSON.parse(document.getElementById(this.searchresultel).textContent));
        }
    },
    mounted: function () {
        this.$refs.paginate.selected = this.page;
    },
    methods: {
        setSelectedIcsGroups: function (categories, value) {
            for (let categoryIndex in categories) {
                if (categories[categoryIndex].value == value) {
                    return categories[categoryIndex];
                }

                var category = this.setSelectedIcsGroups(categories[categoryIndex].children, value);
                if (category != undefined) {
                    return category;
                }
            }
        },
        customLabel: function (option) {
            return option.value + " - " + option.name;
        },
        removeSelectedDirective: function (value) {
            this.selectedDirective = this.selectedDirective.filter(function (item) {
                return item.value != value;
            });
        },
        removeSelectedIcs: function (value) {
            this.selectedIcsGroup = this.selectedIcsGroup.filter(function (item) {
                return item.value != value;
            });
        },
        clearFilter: function (clearQuery) {

            if (clearQuery) {
                this.query = '';
            }

            this.selectedDirective = [];
            this.selectedIcsGroup = [];
            this.selectedLanguage = [];
            this.selectedOrganisation = [];
            this.selectedStatus = [];
            this.selectedCommitteeOption = this.committeeoptions[0].value;
            this.page = 1;
        },
        clearFreeBrowsingFilter: function (clearQuery) {

            if (clearQuery) {
                this.query = '';
            }

            this.selectedDirective = [];
            this.officialJournalPublicationStartDate = null;
            this.officialJournalPublicationEndDate = null;
            this.page = 1;

            this.resetOfficialJournalPublicationStartDate();
            this.resetOfficialJournalPublicationEndDate();
        },
        changeSearchType: function (type) {
            this.searchType = type;
        },
        search: function () {

            if (this.searchType == "topicPages") {
                this.searchTopics();
            } else {
                this.searchProducts();
            }
        },
        searchProducts: function () {

            this.isLoading = true;
            var isFreeStandardBrowsingPortal = window.location.pathname.includes("/hen/search");
            var queryString = jQuery.param(isFreeStandardBrowsingPortal ? this.getFreeBrowsingPortalSearchQuery() : this.getProductSearchQuery(), true);
            var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + "?" + queryString;

            var self = this;
            $.ajax('search/api?' + queryString, {
                beforeSend: function () {
                    window.history.replaceState({ path: newurl }, '', newurl);
                },
                success: function (response) {
                    self.setSearchResults(response);
                },
                error: function () {
                    // TODO Vea käsitlus!
                    alert("Viga");
                    window.location = window.location.protocol + "//" + window.location.host + window.location.pathname
                }
            });
        },
        searchTopics: function () {

            this.isLoading = true;
            var queryString = jQuery.param(this.getTopicSearchQuery(), true);
            var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + "?" + queryString;

            var self = this;
            $.ajax('searchtopics/api?' + queryString, {
                beforeSend: function () {
                    window.history.replaceState({ path: newurl }, '', newurl);
                },
                success: function (response) {
                    self.setSearchResultsTopics(response);
                },
                error: function () {
                    // TODO Vea käsitlus!
                    alert("Viga");
                    window.location = window.location.protocol + "//" + window.location.host + window.location.pathname
                }
            });
        },
        setSearchResults: function (result) {

            if (result && !result.isSuccess) {
                // TODO Vea käsitlus!
                alert("Viga");
                window.location = window.location.protocol + "//" + window.location.host + window.location.pathname
            }

            this.products = result.products;
            this.totalproducts = result.totalproducts;
            this.totaltopics = result.totaltopics;
            this.pageCount = this.setPageCount(result.totalproducts, result.pageSize);
            this.isLoading = false;
        },
        setSearchResultsTopics: function (result) {

            if (result && !result.isSuccess) {
                // TODO Vea käsitlus!
                alert("Viga");
                window.location = window.location.protocol + "//" + window.location.host + window.location.pathname
            }

            this.topics = result.topics;
            this.totaltopics = result.totaltopics;
            this.totalproducts = result.totalproducts;
            this.pageCount = this.setPageCount(result.totaltopics, result.pageSize);
            this.isLoading = false;
        },
        setPage: function (page) {
            this.page = page;
            this.debouncedSearch();
        },
        queryKeyUp: function () {
            this.onlysuggestedproducts = false;
            this.page = 1;
            this.debouncedLongSearch();
        },
        filtersChanged: function () {
            this.onlysuggestedproducts = false;
            this.page = 1;
            this.debouncedSearch();
        },
        setPageCount: function (total, pageSize) {
            if (total > 10000) {
                total = 10000;
                return Math.floor(total / pageSize);
            }
            return Math.ceil(total / pageSize);
        },
        filterByDirective: function (option) {
            this.selectedDirective = [];
            if (option) {
                this.selectedDirective.push(option);
            }
        },
        filterByIcsGroup: function (icsGroup) {
            this.selectedIcsGroup = [];
            if (icsGroup) {
                this.selectedIcsGroup.push(icsGroup);
            }
        },
        getFreeBrowsingPortalSearchQuery: function () {
            var query = {
                query: this.query,
                directives: this.selectedDirective.map(function (d) {
                    return d.value
                }),
                languages: this.selectedLanguage,
                page: this.page,
                filtertype: this.searchType,
                officialJournalPublicationStartDate: this.officialJournalPublicationStartDate,
                officialJournalPublicationEndDate: this.officialJournalPublicationEndDate,
            };

            return query;
        },
        getProductSearchQuery: function () {
            var query = {
                query: this.query,
                directives: this.selectedDirective.map(function (d) {
                    return d.value
                }),
                icsgroups: this.selectedIcsGroup.map(function (i) {
                    return i.value
                }),
                languages: this.selectedLanguage,
                organisations: this.selectedOrganisation,
                statuses: this.selectedStatus,
                page: this.page,
                filtertype: this.searchType,
                committeeoption: this.selectedCommitteeOption,
                onlysuggestedproducts: this.onlysuggestedproducts,
                onlyNewEstonianLanguageProduct: this.onlyNewEstonianLanguageProduct
            };

            return query;
        },
        getTopicSearchQuery: function () {
            var query = {
                query: this.query,
                page: this.page,
                filtertype: this.searchType
            };

            return query;
        },
    },
    watch: {
        selectedOrganisation: {
            handler: function (value, oldValue) {
                this.filtersChanged();
            }
        },
        selectedStatus: {
            handler: function (value, oldValue) {
                this.filtersChanged();
            }
        },
        selectedCommitteeOption: {
            handler: function (value, oldValue) {
                this.filtersChanged();
            }
        },
        selectedLanguage: {
            handler: function (value, oldValue) {
                this.filtersChanged();
            }
        },
        selectedDirective: {
            handler: function (value, oldValue) {
                this.filtersChanged();
            }
        },
        selectedIcsGroup: {
            handler: function (value, oldValue) {
                this.filtersChanged();
            }
        },
        searchType: function () {
            this.page = 1;
            this.search();
            this.clearFilter(false);
        },
        initOfficialJournalPublicationStartDate: function (newVal) {
            this.officialJournalPublicationStartDate = newVal;
            this.page = 1;
            this.search();
        },
        initOfficialJournalPublicationEndDate: function (newVal) {
            this.officialJournalPublicationEndDate = newVal;
            this.page = 1;
            this.search();
        },
        page: {
            handler: function (value, oldValue) {
                // pagination component does not support a better way to control current page
                this.$refs.paginate.selected = value;
            }
        }
    },
    computed: {
        isProductSearchVisible: function () {
            return this.searchType == 'filter' || this.searchType == 'directive' || this.searchType == 'ics';
        },
        isTopicSearchVisible: function () {
            return this.searchType == 'topicPages';
        }
    }

};

window.createSearchApp = function (rootOptions) {
    const app = createApp(rootOptions || {});
    app.component('multiselect', VueMultiselect);
    app.component('paginate', Paginate);
    app.component('product-list-item', ProductListItem);
    app.component('category-tree', CategoryTree);
    app.component('base-checkbox', BaseCheckbox);
    app.component('base-radio', BaseRadio);
    app.component('search-page', SearchPage);
    return app.mount('#search-page-root');
};
